export const getSignatureFieldsForDocument = <T extends { documentId: string }>(
    signatureFields: T[],
    documentId: string
): T[] => {
    if (!documentId) {
        return [];
    }

    return signatureFields.filter(field => field.documentId === documentId);
};
